import { v4 as uuid } from 'uuid';
import BlockComponentButton from '../../../models/BlockComponentValues/BlockComponentButton';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';

class SubBlockMenuData {
  id: string;
  image?: BlockComponentImage;
  title?: BlockComponentText;
  price?: BlockComponentText;
  description?: BlockComponentText;
  button?: BlockComponentButton;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace SubBlockMenuData {
  export function make(image?: string, title?: string, price?: string, description?: string, button?: BlockComponentButton): SubBlockMenuData {
    return {
      id: uuid(),
      image: BlockComponentImage.make(image),
      title: title ? BlockComponentText.make(title) : undefined,
      price: price ? BlockComponentText.make(price) : undefined,
      description: description ? BlockComponentText.make(description) : undefined,
      button,
    };
  }

  export function getDefault(title = 'アイテム名', image = ''): SubBlockMenuData {
    return make(
      image,
      `<p><strong">${title}</strong></p>`,
      '<p>¥00,000（税込）</p>',
      '<p><strong">テキストを入力してください</strong></p>',
      BlockComponentButton.getDefault(),
    );
  }
}

export default SubBlockMenuData;
